<template>
  <div class="level-update-modal-note">
    <p>
      {{ $t("common.components.levelUpdateModal.note.0") }}
    </p>
    <ul>
      <li class="level-update-modal-note--first">
        <i18n-t
          :keypath="`common.components.levelUpdateModal.note.1`"
          tag="span"
        >
          <template #firstIcon>
            <PxIcon
              :size="17"
              class="evidence-provided"
              name="evidence-provided"
            />
          </template>
          <template #text1>
            <i18n-t
              :keypath="`common.components.levelUpdateModal.note.2`"
              tag="p"
            >
              <template #firstIcon>
                <PxIcon :size="16" class="self-assessed" name="self-assessed" />
              </template>
            </i18n-t>
          </template>
        </i18n-t>
      </li>
      <li class="level-update-modal-note--second">
        <i18n-t :keypath="`common.components.levelUpdateModal.note.3`" tag="p">
          <template #text1>
            <i18n-t
              :keypath="`common.components.levelUpdateModal.note.5`"
              tag="span"
            >
              <template #firstIcon>
                <MilestoneStageStatusItem
                  v-bind="inProgressIconProps"
                  :is-clickable="false"
                />
              </template>
            </i18n-t>
          </template>
          <template #text2>
            <i18n-t
              :keypath="`common.components.levelUpdateModal.note.6`"
              tag="span"
            />
          </template>
          <template #firstIcon>
            <PxIcon
              :size="17"
              class="evidence-provided"
              name="evidence-provided"
            />
          </template>
          <template #breakText>
            <i18n-t
              :keypath="`common.components.levelUpdateModal.note.4`"
              class="level-update-modal-note--break-text"
              tag="span"
            />
          </template>
        </i18n-t>
      </li>
      <li class="level-update-modal-note--third">
        <i18n-t :keypath="`common.components.levelUpdateModal.note.7`" tag="p">
          <template #text1>
            <i18n-t
              :keypath="`common.components.levelUpdateModal.note.8`"
              tag="span"
            />
          </template>
          <template #breakText>
            <i18n-t
              :keypath="`common.components.levelUpdateModal.note.9`"
              class="level-update-modal-note--break-text"
              tag="p"
            >
              <template #firstIcon>
                <MilestoneStageStatusItem
                  v-bind="inProgressIconProps"
                  :is-clickable="false"
                />
              </template>
            </i18n-t>
          </template>
        </i18n-t>
      </li>
    </ul>
    <PxButton
      :disabled="loading"
      class="el-button--link-dark"
      data-testid="view-example-button"
      size="small"
      type="link"
      @click="$emitter.emit('change-level-example-modal-visibility')"
    >
      {{ $t("common.components.levelUpdateModal.note.link") }}
    </PxButton>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { EMilestoneStatusType } from "@/modules/milestone-planner/services/data/milestones/milestone.interface";
import MilestoneStageStatusItem from "@/modules/milestone-planner/components/milestone-stage-status-item/milestone-stage-status-item.vue";

export default defineComponent({
  name: "LevelUpdateModalNote",

  components: {
    MilestoneStageStatusItem,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    inProgressIconProps(): any {
      return {
        title: this.$t("milestonePlanner.milestoneGrid.stageStatus.inProgress"),
        icon: EMilestoneStatusType.IN_PROGRESS,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
.level-update-modal-note {
  max-width: 620px;
  padding: 12px 17px 16px 17px;
  margin: 0 auto 16px auto;
  background-color: $alabaster;

  p {
    display: inline;
    font-style: italic;
    margin: 0 0 4px 0 !important;
    letter-spacing: -0.1px;
    font-size: 14px;
    line-height: 20px;
  }

  span,
  p {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.03px;
  }

  ul {
    padding-left: 18px;
    margin: 0;

    li {
      margin-bottom: 2px;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.03px;

      &::marker {
        font-size: 10px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .px-stage-status-item {
    display: inline-flex;
    padding: 0;
    margin-right: 4px;
    vertical-align: middle;
  }

  .evidence-provided,
  .self-assessed {
    margin: 0 4px;
    vertical-align: middle;
  }

  &--break-text {
    font-weight: normal;
    letter-spacing: -0.13px !important;
  }

  .el-button.el-button--link {
    margin-top: 8px;

    &::after {
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-left: 8px;
      vertical-align: middle;

      content: "";
      background: url("#{$assetsPath}/img/icons/arrow--right-dark.svg")
        no-repeat;
      background-size: contain;
      border: none;
    }
  }
}
</style>
